import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { TriagePanel } from "./TriagePanel";
import { LiveStrip } from "./LiveStrip";
import { SidePanel } from "./SidePanel";
import { DeclareIncidentModal } from "./DeclareIncidentModal";
import { HelpOverlay } from "./HelpOverlay";
import { useData } from "../data/DataContext";
import { useUI } from "../data/UIContext";
import { useAuth } from "../auth/AuthContext";
import { ALL_NAV } from "../nav";

export function Layout() {
  const data = useData();
  const ui = useUI();
  const auth = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Global keyboard shortcuts
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (document.activeElement as HTMLElement | null)?.tagName;
      const inInput = tag === "INPUT" || tag === "TEXTAREA";
      if (e.key === "Escape") {
        if (ui.selectedEntity) { ui.closeEntity(); return; }
        if (ui.declareOpen)   { ui.setDeclareOpen(false); return; }
        if (ui.helpOpen)      { ui.setHelpOpen(false); return; }
        if (inInput && tag === "INPUT") { (document.activeElement as HTMLElement).blur(); return; }
        if (ui.searchQuery)   { ui.setSearchQuery(""); }
        return;
      }
      if (inInput) return;
      if (e.key === "?") { ui.setHelpOpen(!ui.helpOpen); return; }
      if (e.key === "i" && auth.canDeclare) { ui.setDeclareOpen(true); return; }
      if (e.key === "t") { document.getElementById("triage-userId")?.focus(); return; }

      // Numeric shortcuts → tabs
      const item = ALL_NAV.find((it) => it.shortcut === e.key);
      if (item) { nav(item.path); }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [nav, ui, auth]);

  if (data.loading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
        <p>Loading command-center-data.json…</p>
      </div>
    );
  }
  if (data.error) {
    return <div className="empty">{data.error}</div>;
  }

  // On /search, the SearchResults component shows; on other paths the active tab.
  const isSearch = loc.pathname === "/search";

  return (
    <div className="app-shell">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="main-pane">
        <Topbar onOpenSidebar={() => setSidebarOpen(true)} />
        <LiveStrip />
        {!isSearch && <TriagePanel />}
        <main className="content"><Outlet /></main>
        <footer className="footer">
          <span>
            <a href="/PLAN.md" target="_blank" rel="noopener">Plan</a> ·
            command-center-api {" · "}
            <a href="/docs" target="_blank" rel="noopener">/docs</a>
          </span>
          <span>Press <kbd>?</kbd> for shortcuts</span>
        </footer>
      </div>
      <SidePanel />
      <DeclareIncidentModal />
      <HelpOverlay />
    </div>
  );
}
